import { render, staticRenderFns } from "./ServicePackageList.vue?vue&type=template&id=f27b8636&scoped=true"
import script from "./ServicePackageList.vue?vue&type=script&lang=js"
export * from "./ServicePackageList.vue?vue&type=script&lang=js"
import style0 from "./ServicePackageList.vue?vue&type=style&index=0&id=f27b8636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b8636",
  null
  
)

export default component.exports